import CryptoJS from 'crypto-js'
// 文件size转换
export const renderSize = (value: number): string => {
	if (!Boolean(value)) {
		return '0 B'
	}
	const unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	let index = 0
	index = Math.floor(Math.log(value) / Math.log(1024))
	let size = value / Math.pow(1024, index)
	//  保留的小数位数
	size = parseFloat(size.toFixed(2))
	return size + ' ' + unitArr[index]
}
/**
 * 数字精度
 * @param num  待转换数字
 * @param lenght  小数点位数 当参数为-1时 按默认规则分配
 */
export const parseNum = (num: number | string, lenght: number = 0): number => {
	// let num0: number = 0
	if (typeof num === 'string') {
		num = num.replace(',', '')
		// eslint-disable-next-line
		if (num != parseFloat(num).toString()) {
			return 0
		}
		num = parseFloat(num)
	}
	// else {
	// 	num0 = num
	// }
	if (lenght === -1) {
		if (num < 10) {
			return parseFloat(num.toFixed(1))
		}
		return parseFloat(num.toFixed(0))
	}
	return parseFloat(num.toFixed(lenght))
}

/**
 * @description 获取文件扩展名图标
 * @param fileExt  扩展名
 */
export const getFileImg = (fileExt: string): string => {
	const fileExtArr = [
		'ai',
		'bmp',
		'doc',
		'docx',
		'exe',
		'file',
		'gif',
		'jpeg',
		'jpg',
		'mpg',
		'pdf',
		'png',
		'ppt',
		'pptx',
		'psd',
		'rar',
		'rm',
		'rmvb',
		'svg',
		'swf',
		'tif',
		'txt',
		'wma',
		'wps',
		'xls',
		'xlsx',
		'zip'
	]
	return fileExtArr.includes(fileExt)
		? new URL(`../../assets/img-file/${fileExt}.png`, import.meta.url).href
		: new URL('../../assets/img-file/png.png', import.meta.url).href
}

/**
 * @description  中文数字
 */
export const parseCNNum = (num: number | string): string => {
	let tomoney: string
	//判断如果传递进来的不是字符的话转换为字符
	if (typeof num == 'number') {
		// eslint-disable-next-line no-new-wrappers
		tomoney = num.toString()
	} else {
		tomoney = num
	}
	tomoney = tomoney.replace(/,/g, '') //替换tomoney中的“,”
	tomoney = tomoney.replace(/ /g, '') //替换tomoney中的空格
	tomoney = tomoney.replace(/￥/g, '') //替换掉可能出现的￥字符

	//字符处理完毕后开始转换，采用前后两部分分别转换
	const part = String(tomoney).split('.')
	let newchar = ''
	let pernewchar = ''
	//判断负数
	if (part[0].charAt(0) == '-') {
		pernewchar = '负'
		part[0] = part[0].substr(1, part[0].length)
	}
	//小数点前进行转化
	for (let i = part[0].length - 1; i >= 0; i--) {
		if (part[0].length > 10) {
			return ''
			//若数量超过拾亿单位，提示
		}
		let tmpnewchar = ''
		const perchar = part[0].charAt(i)
		switch (perchar) {
			case '0':
				tmpnewchar = '零' + tmpnewchar
				break
			case '1':
				tmpnewchar = '壹' + tmpnewchar
				break
			case '2':
				tmpnewchar = '贰' + tmpnewchar
				break
			case '3':
				tmpnewchar = '叁' + tmpnewchar
				break
			case '4':
				tmpnewchar = '肆' + tmpnewchar
				break
			case '5':
				tmpnewchar = '伍' + tmpnewchar
				break
			case '6':
				tmpnewchar = '陆' + tmpnewchar
				break
			case '7':
				tmpnewchar = '柒' + tmpnewchar
				break
			case '8':
				tmpnewchar = '捌' + tmpnewchar
				break
			case '9':
				tmpnewchar = '玖' + tmpnewchar
				break
			default:
				break
		}
		switch (part[0].length - i - 1) {
			case 0:
				tmpnewchar = tmpnewchar + '元'
				break
			case 1:
				if (perchar != '0') {
					tmpnewchar = tmpnewchar + '拾'
				}
				break
			case 2:
				if (perchar != '0') {
					tmpnewchar = tmpnewchar + '佰'
				}
				break
			case 3:
				if (perchar != '0') {
					tmpnewchar = tmpnewchar + '仟'
				}
				break
			case 4:
				tmpnewchar = tmpnewchar + '万'
				break
			case 5:
				if (perchar != '0') {
					tmpnewchar = tmpnewchar + '拾'
				}
				break
			case 6:
				if (perchar != '0') {
					tmpnewchar = tmpnewchar + '佰'
				}
				break
			case 7:
				if (perchar != '0') {
					tmpnewchar = tmpnewchar + '仟'
				}
				break
			case 8:
				tmpnewchar = tmpnewchar + '亿'
				break
			case 9:
				tmpnewchar = tmpnewchar + '拾'
				break
			default:
				break
		}
		newchar = tmpnewchar + newchar
	}
	//小数点之后进行转化
	if (tomoney.indexOf('.') != -1) {
		if (part[1].length > 2) {
			// alert("小数点之后只能保留两位,系统将自动截断");
			part[1] = part[1].substr(0, 2)
		}
		for (let i = 0; i < part[1].length; i++) {
			let tmpnewchar = ''
			const perchar = part[1].charAt(i)
			switch (perchar) {
				case '0':
					tmpnewchar = '零' + tmpnewchar
					break
				case '1':
					tmpnewchar = '壹' + tmpnewchar
					break
				case '2':
					tmpnewchar = '贰' + tmpnewchar
					break
				case '3':
					tmpnewchar = '叁' + tmpnewchar
					break
				case '4':
					tmpnewchar = '肆' + tmpnewchar
					break
				case '5':
					tmpnewchar = '伍' + tmpnewchar
					break
				case '6':
					tmpnewchar = '陆' + tmpnewchar
					break
				case '7':
					tmpnewchar = '柒' + tmpnewchar
					break
				case '8':
					tmpnewchar = '捌' + tmpnewchar
					break
				case '9':
					tmpnewchar = '玖' + tmpnewchar
					break
				default:
					break
			}
			if (i == 0) {
				tmpnewchar = tmpnewchar + '角'
			}
			if (i == 1) {
				tmpnewchar = tmpnewchar + '分'
			}
			newchar = newchar + tmpnewchar
		}
	}
	newchar = pernewchar + newchar
	//替换所有无用汉字
	while (newchar.search('零零') != -1) {
		newchar = newchar.replace('零零', '零')
	}
	newchar = newchar.replace('零亿', '亿')
	newchar = newchar.replace('亿万', '亿')
	newchar = newchar.replace('零万', '万')
	newchar = newchar.replace('零元', '元')
	newchar = newchar.replace('零角', '')
	newchar = newchar.replace('零分', '')
	if (newchar.charAt(newchar.length - 1) == '元') {
		newchar = newchar + '整'
	}
	return newchar
}

// 接口返回的参数中英文显示
export const at = (data: DefaultClass, prop: string, propEn?: string) => {
	const body = document.documentElement as HTMLElement
	const lang = body.getAttribute('lang')
	const enProp = propEn ? propEn : prop + 'En'
	return lang == 'en' ? data[enProp] : data[prop]
}

/**
 * 获取汉字简拼
 * @param chStr
 * @returns {string}
 */
export const getApiUrl = (apiUrl: string) => {
	return apiUrl.replace('/{apiPre}/', process.env.VITE_API_PRE || '')
}

export const formatDecimal = (value: string): string => {
	const regex = /^\d*\.?\d{0,2}$/
	if (regex.test(value)) {
		return value
	} else {
		return value.slice(0, -1)
	}
}
export const formatCurrency = (value: number, minimumFractionDigits: number = 2): string => {
	// return new Intl.NumberFormat("zh-CN", {
	// 	style: "currency",
	// 	currency: "CNY",
	// 	minimumFractionDigits: 2
	// }).format(value)
	return new Intl.NumberFormat('zh-CN', {
		style: 'decimal',
		minimumFractionDigits: minimumFractionDigits,
		maximumFractionDigits: 20
	}).format(value)
}
export const getIcon = (fileType: string) => {
	let imageUrl = ''
	if (fileType == 'doc' || fileType == 'docx') {
		imageUrl = new URL('@/assets/images/doc-mgt/word.png', import.meta.url).href
	} else if (fileType == 'pdf') {
		imageUrl = new URL('@/assets/images/doc-mgt/pdf2.png', import.meta.url).href
	} else if (fileType == 'xls' || fileType == 'xlsx') {
		imageUrl = new URL('@/assets/images/doc-mgt/excel.png', import.meta.url).href
	} else if (fileType == 'mp3' || fileType == 'm4a' || fileType == 'wav' || fileType == 'aac' || fileType == 'flac') {
		// 音频
		imageUrl = new URL('@/assets/images/doc-mgt/audio.png', import.meta.url).href
	} else if (fileType == 'zip' || fileType == 'rar' || fileType == '7z' || fileType == 'tar' || fileType == 'gz') {
		// 压缩包
		imageUrl = new URL('@/assets/images/doc-mgt/compress.png', import.meta.url).href
	} else if (fileType == 'html' || fileType == 'htm') {
		// html
		imageUrl = new URL('@/assets/images/doc-mgt/html.png', import.meta.url).href
	} else if (
		fileType == 'jpg' ||
		fileType == 'png' ||
		fileType == 'jpeg' ||
		fileType == 'gif' ||
		fileType == 'bmp' ||
		fileType == 'svg' ||
		fileType == 'psd'
	) {
		// 图片
		imageUrl = new URL('@/assets/images/doc-mgt/image.png', import.meta.url).href
	} else if (fileType == 'md' || fileType == 'mdx' || fileType == 'rmd') {
		// markdown
		imageUrl = new URL('@/assets/images/doc-mgt/markdown.png', import.meta.url).href
	} else if (
		fileType == 'mp4' ||
		fileType == 'mkv' ||
		fileType == 'avi' ||
		fileType == 'mov' ||
		fileType == 'flv' ||
		fileType == 'wmv'
	) {
		// 视频
		imageUrl = new URL('@/assets/images/doc-mgt/video.png', import.meta.url).href
	} else if (fileType == 'folder') {
		imageUrl = new URL('@/assets/images/doc-mgt/folder.png', import.meta.url).href
	} else if (fileType == 'wpsFolder-old') {
		// 废弃图标
		imageUrl = new URL('@/assets/images/doc-mgt/wps-fold-up.png', import.meta.url).href
	} else if (fileType == 'wpsFile') {
		imageUrl = new URL('@/assets/images/doc-mgt/wps-file-up.png', import.meta.url).href
	} else if (fileType == 'ppt' || fileType == 'pptx') {
		imageUrl = new URL('@/assets/images/doc-mgt/ppt1.png', import.meta.url).href
	} else {
		imageUrl = new URL('@/assets/images/doc-mgt/document.png', import.meta.url).href
	}
	return imageUrl
}
export const analysisFileTypeList = () => {
	const fileTypeList = [
		'doc',
		'docx',
		'pdf',
		'txt',
		'ppt',
		'pptx',
		'xls',
		'xlsx',
		'png',
		'jpeg',
		'md',
		'json',
		'eml',
		'html',
		'jpg'
	]
	return fileTypeList
}
// 压缩包格式的文件列表
export const zipFileList = () => {
	const fileTypeList = ['zip', 'rar', '7z', 'tar.gz', 'dmg']
	return fileTypeList
}
export const buildQueryString = filters => {
	// 过滤掉 name 为空的条件
	const validFilters = filters.filter(filter => filter.name && filter.name.trim() !== '')

	return validFilters
		.map((filter, index) => {
			// 构建每个条件单元: (字段名:值(匹配模式))
			const condition = `(${filter.selectBegin}:${filter.name}(${filter.selectEnd}))`

			// 对于第一个有效条件，不添加关系运算符
			if (index === 0) {
				return condition
			} else {
				return filter.relation + condition
			}
		})
		.join('') // 直接连接所有部分
}
/**
 * 判断字符串是否包含HTML标签
 * @param str 待检查的字符串
 * @returns 是否包含HTML标签
 */
export function hasHtmlTags(str: string): boolean {
	// 匹配HTML标签的正则表达式
	const htmlTagRegex = /<\/?[^>]+(>|$)/
	return htmlTagRegex.test(str)
}

/**
 * 移除字符串中的所有HTML标签
 * @param str 包含HTML标签的字符串
 * @returns 移除标签后的纯文本
 */
export function stripHtmlTags(str: string): string {
	if (!str) return ''
	// 移除所有HTML标签的正则表达式
	const htmlTagRegex = /<\/?[^>]+(>|$)/g
	return str.replace(htmlTagRegex, '')
}
/**
 * 如果字符串包含HTML标签则返回纯文本，否则返回原字符串
 * @param str 待处理的字符串
 * @returns 处理后的字符串
 */
export function extractTextIfHasHtml(str: string): string {
	return hasHtmlTags(str) ? stripHtmlTags(str) : str
}
// 文件上传文件类型增加以下格式限制，禁止上传
export const dangerousExtensions = [
	// 可执行文件
	'exe',
	'msi',
	'bat',
	'cmd',
	'ps1',
	'vbs',
	'js',
	'jse',
	'vbe',
	'php',
	'asp',

	// 系统文件
	'dll',
	'sys',
	'drv',
	'ocx',

	// 脚本文件
	'sh',
	'bash',
	'py',
	'pl',

	// 其他危险格式
	'scr',
	'pif',
	'com',
	'hta'
]
// 配置参数
const config = {
	algorithm: 'AES',
	mode: CryptoJS.mode.ECB,
	padding: CryptoJS.pad.Pkcs7,
	key: 'Jcaufr3&XUK9b2I&'
}
// 加密函数
export function encrypt(plaintext: string): string {
	const key = CryptoJS.enc.Utf8.parse(config.key)
	// const key = CryptoJS.enc.Utf8.parse(config.key)
	// const iv = CryptoJS.enc.Utf8.parse(config.iv)

	const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
		mode: config.mode,
		padding: config.padding
	})

	return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
}
// 解密函数
export function decrypt(ciphertext: string): string {
	const key = CryptoJS.enc.Utf8.parse(config.key)
	const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
		mode: config.mode,
		padding: config.padding
	})
	return CryptoJS.enc.Utf8.stringify(decrypted)
}
